window.setLoadingPageInterval = ->
  window.intervalCount = 0
  window.intervalID = setInterval(()->
    checkAccountStatus()
  , 1000)
  if $("#purchase-waiting-spinner").length == 0
    clearInterval(intervalID)
  $(document).on 'turbolinks:before-render', ->
    clearInterval(intervalID)

# Check account status for when the user is able to enter the site.
window.checkAccountStatus = ->
  intervalCount += 1
  if (intervalCount >= 60)
    $("#purchase-waiting-spinner").hide()
    $("#after-purchase-error").show()
    clearInterval(intervalID)
    return
  $.ajax locale + "/after_purchase_finished",
    type: "GET"
    dataType: 'json'
    success:  (data, textStatus, jqXHR) ->
      if(data.access_type == "true")
        $("#purchase-waiting-spinner").hide()
        $("#thank-you-after-wait-header").show()
        $("#after-purchase-thank-you").show()
        $(".thank-you-lti").removeClass("d-none")
        $("#thank-you-before-wait-header").hide()
        thank_you_duration_lti = $("#thank-you-duration-text-lti")
        if (data.duration_text)
          $("#thank-you-duration-text").text(data.duration_text)
        if (data.lti_duration_text && thank_you_duration_lti)
          thank_you_duration_lti.text(data.lti_duration_text)
        if($("#ws-exit-loading-screen").length)
          location.href = $("#ws-exit-loading-screen").attr("href")
        clearInterval(intervalID)
        return

# Check SSO authentication of LMS user
window.checkSsoAuthentication = (queryParams) ->
  $.ajax "/after_sso_authentication?app=courseware",
    type: "GET"
    dataType: "json"
    success: (data, textStatus, jqXHR) ->
      if (data.lms_link_status)
        window.location.href = window.location.origin + "/user_product" + queryParams
      else
        console.log("lms_link_status: " + data.lms_link_status)


$(document).on 'turbolinks:load', ->
  $("#prevent-paste").on 'paste',(e)->
    e.preventDefault()
  $("#reminder-popup").modal("show")
  $("#close-reminder-popup-id").on 'click', ->
    $("#reminder-popup").modal("hide")
  $("#popup-purchase-button-id").on 'click', ->
    $("#reminder-popup").modal("hide")
  if $("#purchase-waiting-spinner").length > 0
    setLoadingPageInterval()

  $productDurationSelect = $("#fastspring-product-duration-select")
  $productDurationConfirmationModal = $("#fastspring-product-duration-confirmation-modal")
  $productDurationConfirmButton = $("#fastspring-product-duration-confirm-button")

  setFastspringProductId = (productId) ->
    $("#fastspring-card .product_id").val(productId)

  buildFastspringTag = ->
    fastspring.builder.tag({
      'user_id': $("#purchase_user_id").val(),
      'user_school': $("#purchase_school_id").val(),
      'language': $("#language").val(),
      'environment': $("#environment").val()
    })

  updateFastspringProduct = (productId) ->
    fastspring.builder.reset()

    # If purchasing WS 1 year sub and they were a WS SL user whose institution's order has expired provide discount
    if productId == 'web-suite-subscription-1-year' and $("#order_expired").val() == "true"
      fastspring.builder.promo('ALKDKLAYLNLNDVYAQODKMMFUVL')

    # TODO: New Environment
    # Plug in the live product on production and the test product elsewhere.
    if $("#environment").val() != "production"
      fastspring.builder.add('test-'+productId)
    else
      fastspring.builder.add(productId)

    buildFastspringTag()

  loadFastspringCheckout = (productId) ->
    updateFastspringProduct(productId)
    fastspring.builder.checkout()

  resetFastspringProductDuration = ->
    defaultProductId = $productDurationSelect.data("default-product-id")
    $productDurationSelect.val(defaultProductId)
    setFastspringProductId(defaultProductId)
    updateFastspringProduct(defaultProductId)

  if $productDurationSelect.length > 0
    $productDurationSelect.off("change.fastspringProductDuration").on "change.fastspringProductDuration", ->
      selectedProductId = $(this).val()
      defaultProductId = $(this).data("default-product-id")

      setFastspringProductId(selectedProductId)
      updateFastspringProduct(selectedProductId)

      if selectedProductId == defaultProductId
        return

      $productDurationConfirmationModal.data("selected-product-id", selectedProductId)
      $productDurationConfirmationModal.data("duration-confirmed", false)
      $productDurationConfirmationModal.modal("show")

    $productDurationConfirmButton.off("click.fastspringProductDuration").on "click.fastspringProductDuration", ->
      $productDurationConfirmationModal.data("duration-confirmed", true)
      $productDurationConfirmationModal.modal("hide")

    $productDurationConfirmationModal.off("hidden.bs.modal.fastspringProductDuration").on "hidden.bs.modal.fastspringProductDuration", ->
      unless $productDurationConfirmationModal.data("duration-confirmed") == true
        resetFastspringProductDuration()

      $productDurationConfirmationModal.removeData("selected-product-id")
      $productDurationConfirmationModal.removeData("duration-confirmed")

  $(".fastspring-purchase-button").on "click", (e)->
    e.preventDefault();

    # Get the product ID which is stored as the value of a hidden input sibling element
    $product_id = $(this).siblings(".product_id").val();
    loadFastspringCheckout($product_id)
